export default __webpack_public_path__ + "static/coinmarketcap-eb2ad0d6c5ea966e1db9c91f266e8b3f.svg";